import { render, staticRenderFns } from "./ParticaCardMax.vue?vue&type=template&id=eb28ff94&scoped=true&"
import script from "./ParticaCardMax.vue?vue&type=script&lang=ts&"
export * from "./ParticaCardMax.vue?vue&type=script&lang=ts&"
import style0 from "./ParticaCardMax.vue?vue&type=style&index=0&id=eb28ff94&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb28ff94",
  null
  
)

export default component.exports